const type = 'CLOSE_CARD_PASSWORD_CHANGE';

const closeCardPasswordChange = () => ({
  type,
});

export { type };
export default closeCardPasswordChange;
